export * from "./ArticleRestrictedContent.builder";
